import { CanonicalCategory, CanonicalCategoryCMeta, Category } from '../../types/Category';
import { Metatags } from '../../types/Metatags';

const getSEOValueFromCanonical = (
  canonicalCategory: CanonicalCategory | undefined
) => (
  key: keyof Metatags | keyof CanonicalCategoryCMeta,
  defaultValue: string | boolean
) => {
  const value = canonicalCategory?.meta[key];
  if (![null, undefined].includes(value)) {
    return value;
  }
  return defaultValue;
};

export const getMetatags = (
  category: Category,
  baseCanonicalUrl: string,
  canonicalCategory: CanonicalCategory,
  searchUrl: string,
  isLowResults: boolean
): Metatags => {
  const getSEOValueOrDefault = getSEOValueFromCanonical(canonicalCategory);

  const seoTitle = getSEOValueOrDefault('metaName', category.metaTitle || category.title);
  const h1 = getSEOValueOrDefault('h1', category.title || category.name);

  //Only show filters in canonical url if there are more than 2 results
  searchUrl = isLowResults ? '' : searchUrl;

  let modifiedCanonicalUrl = baseCanonicalUrl;
  if (searchUrl.length > 0) {
    const cleanedQueryString = removeExtraFilters(searchUrl);
    //Use the baseCanonicalUrl for any canonical urls in the static urls array, otherwise add the query params
    if (!staticUrls.includes((category.urlPath + cleanedQueryString).toLowerCase())) {
      modifiedCanonicalUrl = baseCanonicalUrl + cleanedQueryString;
    }
  }

  return {
    h1,
    seoTitle,
    metaTitle: seoTitle,
    metaDescription: getSEOValueOrDefault('metaDescription', category.metaDescription),
    metaKeywords: getSEOValueOrDefault('metaKeywords', category.metaKeywords),
    isIndexable: getSEOValueOrDefault('isIndexable', true),
    canonicalUrl: getSEOValueOrDefault('canonicalUrl', modifiedCanonicalUrl)
  };
};

//For SEO purposes, we will only show one filter per filter category. Remove any extra from the canonical url.
export const removeExtraFilters = (queryString: string): string => {
  // Remove the initial question mark if present
  const query = queryString.startsWith('?') ? queryString.slice(1) : queryString;

  let filters = query.split('&');

  filters = filters.map(pair => {
    const pairArray = pair.split('=');
    const key = pairArray[0];
    let value = pairArray[1];
    value = value.split('%2B')[0];
    return `${key}=${value}`;
  });

  return '?' + filters.join('&');
};

const staticUrls = [
  '/photo-prints?print_frame_size=small',
  '/photo-prints?print_frame_size=medium',
  '/photo-prints?print_frame_size=large',
  '/photo-prints?print_frame_size=extra-large',
  '/photo-prints?occasion=wedding',
  '/photo-prints?occasion=family',
  '/photo-prints?occasion=everyday',
  '/photo-prints?occasion=travel',
  '/photo-prints?occasion=baby%2fkids',

  '/frames?print_frame_size=small',
  '/frames?print_frame_size=medium',
  '/frames?print_frame_size=large',
  '/frames?print_frame_size=extra-large',
  '/frames?frame_material=wood',
  '/frames?frame_material=metal',
  '/frames?frame_material=canvas',

  '/photo-calendars?calendar_type=refills',

  '/wedding/photo-albums?wedding_book_type=layflat',
  '/wedding/photo-albums?wedding_book_type=hardcover'
];
